module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popover', {
    attrs: {
      "placement": _vm.placement,
      "title": _vm.title,
      "show": _vm.show
    },
    on: {
      "update:show": function($event) {
        _vm.show = $event
      }
    }
  }, [_c('btn-group', {
    slot: "content"
  }, [_c('btn', {
    attrs: {
      "state": "success"
    },
    on: {
      "click": _vm._ok
    }
  }, [_c('fa', {
    attrs: {
      "name": "check"
    }
  }), _vm._v(" " + _vm._s(_vm.okText) + "\n    ")], 1), _vm._v(" "), _c('btn', {
    attrs: {
      "state": "danger"
    },
    on: {
      "click": _vm._cancel
    }
  }, [_c('fa', {
    attrs: {
      "name": "close"
    }
  }), _vm._v(" " + _vm._s(_vm.cancelText) + "\n    ")], 1)], 1), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c748fac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popover/popconfirm.vue
// module id = 554
// module chunks = 84